export default __webpack_public_path__ + "static/media/detail_big_9_4.999f0a65.jpg";